/*
 * scs-cart-cards.js — Controller für scs-product-card-Karten + scs-cart-sheet.
 * Portiert aus dem Karten-/Sheet-Skript von scs-outlet.liquid, aber:
 *   · ohne Kategorie-Filter und ohne Rabatt-Sortierung (Story behält die kuratierte Collection-Reihenfolge),
 *   · scse__-Namespace, multi-section-/multi-root-safe (initialisiert alle [data-scse-root]),
 *   · nur Varianten-Modus im Bottom-Sheet.
 * Quick-Add: Single-Variant-Karte submittet das product-form direkt (AJAX-Add via theme.js
 * product-form-Custom-Element). Multi-Variant-Karte (data-opens-sheet) öffnet den Sheet; nach
 * Variantenwahl klickt der Sheet-ATC den jetzt korrekt befüllten Submit-Button.
 */
(function () {
  function nid(x) {
    x = String(x == null ? '' : x);
    var i = x.lastIndexOf('/');
    return i > -1 ? x.slice(i + 1) : x;
  }

  function initRoot(root) {
    if (root.dataset.scseInit) return;
    root.dataset.scseInit = '1';
    var sid = root.getAttribute('data-scse-root');
    var cards = Array.prototype.slice.call(root.querySelectorAll('.scse__card'));

    // Bild-Carousel: Dots folgen der Scroll-Position
    cards.forEach(function (card) {
      var car = card.querySelector('.scse__media--carousel');
      if (!car) return;
      var dots = card.querySelectorAll('.scse__dot');
      if (!dots.length) return;
      var ticking = false;
      car.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          var i = Math.round(car.scrollLeft / Math.max(1, car.clientWidth));
          dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
        });
      }, { passive: true });
    });

    // ---------- Bottom-Sheet ----------
    var sheet = document.getElementById('scse-sheet-' + sid);
    if (!sheet) return;
    var panel = sheet.querySelector('.scse-sheet__panel');
    var optBox = sheet.querySelector('[data-sheet-options]');
    var elPrice = sheet.querySelector('[data-sheet-price]');
    var elRrp = sheet.querySelector('[data-sheet-rrp]');
    var elDisc = sheet.querySelector('[data-sheet-disc]');
    var atcBtn = sheet.querySelector('[data-sheet-atc]');
    var curCard = null, lastFocus = null;

    function setSheetPrice(p, r, d) {
      elPrice.textContent = p || '';
      elRrp.textContent = r || '';
      elRrp.style.display = r ? '' : 'none';
      var dd = parseInt(d || '0', 10);
      elDisc.textContent = dd > 0 ? ('−' + dd + ' %') : '';
      elDisc.style.display = dd > 0 ? '' : 'none';
    }

    function openSheet(card) {
      curCard = card;
      lastFocus = document.activeElement;
      sheet.querySelector('[data-sheet-title]').textContent = card.dataset.title || '';
      var th = sheet.querySelector('[data-sheet-thumb]');
      if (card.dataset.thumb) { th.src = card.dataset.thumb; th.parentElement.style.display = ''; }
      else { th.parentElement.style.display = 'none'; }
      optBox.innerHTML = '';

      if (card.dataset.hasVariants === '1') {
        var vEl = card.querySelector('[data-scse-variants]');
        var vars = [];
        try { vars = JSON.parse(vEl.textContent); } catch (e) {}
        var vWrap = document.createElement('div');
        vWrap.className = 'scse-sheet__vars';
        vWrap.setAttribute('role', 'group');
        vWrap.setAttribute('aria-label', 'Variante wählen');
        vars.forEach(function (s) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'scse-sheet__var' + (s.active ? ' is-active' : '');
          b.disabled = !s.avail;
          b.setAttribute('aria-pressed', s.active ? 'true' : 'false');
          b.innerHTML = '<span class="scse-sheet__var-title">' + s.title + (s.avail ? '' : ' · ausverkauft') + '</span><span class="scse-sheet__var-price">' + s.price + '</span>';
          b.addEventListener('click', function () {
            vWrap.querySelectorAll('.scse-sheet__var').forEach(function (x) { var on = x === b; x.classList.toggle('is-active', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
            setSheetPrice(s.price, s.rrp, s.disc);
            var input = card.querySelector('[data-scse-vid]');
            if (input) input.value = nid(s.vid);
          });
          vWrap.appendChild(b);
          if (s.active) {
            setSheetPrice(s.price, s.rrp, s.disc);
            var input = card.querySelector('[data-scse-vid]');
            if (input) input.value = nid(s.vid);
          }
        });
        optBox.appendChild(vWrap);
      }

      sheet.hidden = false;
      requestAnimationFrame(function () { sheet.classList.add('is-open'); });
      document.documentElement.style.overflow = 'hidden';
      panel.focus({ preventScroll: true });
    }

    function closeSheet() {
      sheet.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      window.setTimeout(function () { sheet.hidden = true; }, 220);
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
      curCard = null;
    }

    sheet.addEventListener('click', function (e) { if (e.target.closest('[data-sheet-close]')) closeSheet(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sheet.hidden) closeSheet(); });

    atcBtn.addEventListener('click', function () {
      if (!curCard) return;
      var btn = curCard.querySelector('.scse__form .scse__add');
      var card = curCard;
      closeSheet();
      if (btn) { card.dataset.sheetConfirm = '1'; btn.click(); }
    });

    // Plus-Button: mit Varianten -> Sheet öffnen statt direkt zu submitten
    cards.forEach(function (card) {
      var btn = card.querySelector('.scse__form .scse__add[data-opens-sheet]');
      if (!btn) return;
      btn.addEventListener('click', function (e) {
        if (card.dataset.sheetConfirm === '1') { card.dataset.sheetConfirm = ''; return; }
        e.preventDefault();
        e.stopPropagation();
        openSheet(card);
      });
    });
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-scse-root]');
    Array.prototype.forEach.call(roots, initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
